export default __webpack_public_path__ + "static/Hero-82545cd6267ac6cc174e981d0132352f.mp4";